// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"44e55187","379":"7d70bdf1","453":"4c3cf9e1","638":"ce613cf2","706":"696083b6","886":"278e077d"}[chunkId] + ".chunk.js";
};